export default __webpack_public_path__ + "static/worker-using-machine-c9354f30a087ae7daf7aa63d1c08b237.jpg";